

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';

class QueueListItem {
  public constructor(public header: string,
                     public description: string,
                     public data: api.DelayEffect) {}
}

@Component({
  components: {
    CharacterIcon,
  },
})
export default class SkillList extends Vue {
  @Prop() public delayEffects!: api.DelayEffect[];
  @Prop() public towns!: api.Town[];
  @Prop({
    default: () => new api.DelayEffect(),
  }) public value!: api.DelayEffect;
  private queues: QueueListItem[] = [];

  @Watch('delayEffects')
  public onTypesChanged() {
    this.queues = [];
    this.delayEffects.forEach((d) => {
      if (d.type === 1) {
        // 都市投資
        const towns = this.towns.filter((t) => t.id === d.townId);
        if (towns.length > 0) {
          const town = towns[0];
          this.queues.push(new QueueListItem(town.name + ' 都市投資', '都市 ' + town.name + ' で都市投資をおこないます', d));
        }
      } else if (d.type === 3) {
        // アイテム生産
        const items = def.CHARACTER_ITEM_TYPES.filter((it) => it.id === d.typeData);
        if (items.length > 0) {
          const item = items[0];
          this.queues.push(new QueueListItem(item.name + ' 生産', 'アイテム「' + item.name + '」を生産します', d));
        }
      }
    });
  }

  public mounted() {
    this.onTypesChanged();
  }
}
